/* imods buy box (refurbished units and parts). SPEC §7, §8, §12, §15. Reads the variants embedded once by Liquid
   ([data-imods-variants], prices in cents) and the one rules block (#imods-rules). No "$" amount is typed here. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { $$('[data-imods-product-root]').forEach(init); });

  function capOf(v) {
    var m = /(\d+)\s?(GB|TB)/i.exec(v || '');
    if (!m) return null;
    return { label: m[1] + m[2].toUpperCase(), gb: (+m[1]) * (m[2].toUpperCase() === 'TB' ? 1024 : 1) };
  }

  function init(root) {
    var I = window.imods;
    var D = JSON.parse($('[data-imods-variants]', root).textContent);
    var R = {};
    try { R = JSON.parse(($('#imods-rules') || {}).textContent || '{}'); } catch (e) {}
    var form = $('[data-imods-form]', root);
    var soldPanel = $('[data-imods-soldout]', root);
    if (I.state === 'sold-out' && soldPanel) {         // QA route (test theme only)
      soldPanel.hidden = false;
      if (form) form.hidden = true;
      $$('[data-imods-trust], .im-summary, [data-imods-sticky]', root).forEach(function (x) { x.hidden = true; });
      return;
    }
    if (!form) return;
    var money = I.money;
    var kind = D.kind, fam = D.family;
    var flashBuild = /flash/i.test(D.title || '') && kind === 'unit';
    // N-23: every size of a flash mod kit is flash ("256GB (+$59.95)" carries no "flash"); labels only, the rules keep isFlash
    var flashKit = kind === 'part' && /flash mod (kit|service)/i.test(D.title || '');   // round 1 (I-23): the kits became services
    var famRules = (R.storage || {})[fam] || {};
    var b2000Fams = (R.battery2000 || {}).families || [];

    var fsets = $$('fieldset[data-opt]', form).filter(function (f) { return f.getAttribute('data-opt') !== 'finish'; });
    var byRole = {};
    fsets.forEach(function (fs) { var r = fs.getAttribute('data-opt'); if (!byRole[r]) byRole[r] = fs; });
    function idxOf(role) { var fs = byRole[role]; return fs ? +fs.getAttribute('data-index') : -1; }
    var iCase = idxOf('case'), iBat = idxOf('battery'), iSto = idxOf('storage'), iSvc = idxOf('service'), iAdd = idxOf('addon'), iBox = idxOf('box');
    // every add-on group: the 4th Gen front panel has two ("Add-On", "Upgrade and save"); the flash kits "Add a new battery" (N-19, N-23)
    var addSets = fsets.filter(function (f) { return /^(addon|addbattery)$/.test(f.getAttribute('data-opt')); });
    var addIdx = addSets.map(function (f) { return +f.getAttribute('data-index'); });
    function valsAt(fs) { return $$('input[data-optval]', fs).map(function (x) { return x.value; }); }
    function noneAt(fs) { return valsAt(fs).filter(isNone)[0]; }
    // store change set (owner 2026-10-13, §22): the music transfer tick on the 8 flash service pages (sections/imods-product.liquid)
    var mtFs = $('[data-imods-mt]', form), mtTick = mtFs ? $('input[data-mt-tick]', mtFs) : null;
    var mtPrice = mtFs ? +mtFs.getAttribute('data-mt-price') : 0, mtId = mtFs ? +mtFs.getAttribute('data-mt-id') : 0;

    function isNewCase(v) { return /^(brand new|new case)/i.test(v || ''); }   // round 1 (I-15): old and new store names
    function is2000(v) { return /2000/.test(v || ''); }
    function is1200(v) { return /1200/.test(v || ''); }   // round 1 (G-08): the 4th Gen / Photo 1200mAh extended-life battery
    function batWord(v) { return is2000(v) ? '2000mAh' : (is1200(v) ? '1200mAh' : ''); }
    function isFlash(v) { return flashBuild || /flash|included/i.test(v || ''); }
    function isFlashSize(v) { return flashKit || isFlash(v); }
    // "Yes - professional installation …" and the 4th Gen front panel's "Professional Installation (+…)" (as imods-core.js yesInst)
    function isInstall(v) { return (/^yes/i.test(v || '') && /install/i.test(v || '')) || /^professional installation/i.test(v || ''); }
    function isInstallBox(v) { return isInstall(v) && /box|label/i.test(v || ''); }
    function isYes(v) { return /^yes/i.test(v || ''); }
    function isNone(v) { return !v || /^none$/i.test(v) || /^no$/i.test(v); }
    // G-34: add-ons are labelled from their own value; only the flash add-ons swap kit <-> service with the service choice
    function isFlashAddon(v) { return /flash mod (kit|service)/i.test(v || ''); }
    function addonTwin(v, vals) {
      if (!isFlashAddon(v)) return null;
      var t = /kit/i.test(v) ? v.replace(/kit/i, 'service') : v.replace(/service/i, 'kit');
      return vals.indexOf(t) >= 0 ? t : null;
    }
    // I-23 (owner 2026-10-11): the flash mod is a service: under You Fix It a flash service add-on with no kit twin comes off
    // (a flash + battery value keeps the new battery)
    function diyFlashDrop(v, vals) {
      if (/battery/i.test(v)) { var b = vals.filter(function (x) { return /^\+?\s*new battery/i.test(x); })[0]; if (b) return b; }
      return vals.filter(isNone)[0] || v;
    }
    function addonName(v) {
      var n = String(v || '').replace(/^\+\s*/, '').replace(/\s*\([^)]*\)\s*$/, '');
      n = n.replace(/flash mod (kit|service)/i, 'flash mod').replace(/\s*\+\s*battery/i, ' and new battery');
      return n.charAt(0).toUpperCase() + n.slice(1);
    }
// W6 (owner section 38, 2026-10-17): the battery add-on reads "+ New battery (5% off, 25% off with We Fix It)": the badge names the
    // saving of the chosen fix (We Fix It = installed); a value with one saving, e.g. "(5% off)", keeps its own words
    function saveTag(v, inst) {
      var m = /\(([^)]*\boff\b[^)]*)\)/i.exec(v || ''); if (!m) return '';
      var ps = m[1].split(/\s*,\s*/), we = ps.filter(function (p) { return /with we fix it/i.test(p); })[0];
      if (!we) return /off$/i.test(m[1]) ? m[1] : '';
      return inst ? we.replace(/\s*with we fix it\s*$/i, '') : (ps.filter(function (p) { return p !== we; })[0] || '');
    }
    function addName(fs, v) {
      if (fs.getAttribute('data-opt') !== 'addbattery') return isNone(v) ? (valsAt(fs).some(isFlashAddon) ? 'No flash upgrade' : 'No add-on') : addonName(v);
      return isNone(v) ? 'No new battery' : (is2000(v) ? '2000mAh battery' : (is1200(v) ? '1200mAh extended-life battery' : 'New battery'));
    }

    // ---- which variants may ever be offered (interim guards until the catalogue round, SPEC §18)
    var stockDriveGuard = b2000Fams.indexOf(fam) >= 0 && iBat >= 0 && iSto >= 0;
    var cap30 = fam === '5G' && /^30GB/i.test(D.capacity || '') && famRules.cap30;
    var capMax = cap30 ? capOf(famRules.cap30.max).gb : null;
    function storageAllowed(v) {
      if (iSto < 0 || v == null) return true;
      var c = capOf(v);
      if (!c) return true;
      if (isFlash(v) && famRules.flashAllowed && famRules.flashAllowed.indexOf(c.label) < 0 && !/included/i.test(v)) return false;
      if (capMax && isFlash(v) && c.gb > capMax) return false;
      return true;
    }
    function offered(v) {
      if (!v || !v.available) return false;
      if (stockDriveGuard && is2000(v.o[iBat]) && !isFlash(v.o[iSto])) return false;
      if (kind === 'part' && D.is2000 && iSvc >= 0 && !isInstall(v.o[iSvc])) return false; // FIX-9: the 2000mAh part is installed only
      // FIX-10 set 7 (f): the 2000mAh add-on is installed only too (FIX-9 set 6 hides it under You Fix It): never a price
      if (kind === 'part' && iSvc >= 0 && !isInstall(v.o[iSvc]) && addIdx.some(function (i) { return is2000(v.o[i]); })) return false;
      if (iSto >= 0 && !storageAllowed(v.o[iSto])) return false;
      return true;
    }
    function find(vals) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) if (vals[j] != null && v.o[j] !== vals[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function price(vals) { var v = find(vals); return v && offered(v) ? v.price : null; }
    function lowestWith(i, val) { var lo = null; D.variants.forEach(function (v) { if (v.o[i] === val && offered(v) && (lo == null || v.price < lo)) lo = v.price; }); return lo; }
    // FIX-10 set 7 (f): the choices a click on service card val would give, as the add-on panel normalises them (imods-core.js
    // addonPanel.normalize): the flash kit and the flash service swap with the fix method; under You Fix It the 2000mAh add-on
    // and the box come off (both are We Fix It only)
    function forService(vals, val) {
      var c = withVal(vals, iSvc, val), inst = isInstall(val);
      addSets.forEach(function (fs) {
        var i = +fs.getAttribute('data-index'), all = valsAt(fs), tw = addonTwin(c[i], all);
        if (tw && (inst ? /kit/i.test(c[i]) : /service/i.test(c[i]))) c[i] = tw;
        else if (!tw && !inst && isFlashAddon(c[i]) && /service/i.test(c[i])) c[i] = diyFlashDrop(c[i], all);
        if (!inst && is2000(c[i])) c[i] = noneAt(fs) || c[i];
      });
      if (iBox >= 0 && !inst) c[iBox] = $$('input[data-optval]', byRole.box).map(function (x) { return x.value; }).filter(function (x) { return !isYes(x); })[0];
      return c;
    }
    function withVal(vals, i, val) { var c = vals.slice(); if (i >= 0) c[i] = val; return c; }

    // ---- remove chips that are never offered (5G 30GB above 256GB; family caps)
    if (iSto >= 0) $$('label[data-value]', byRole.storage).forEach(function (l) { if (!storageAllowed(l.getAttribute('data-value'))) l.remove(); });

    // ---- start state
    var cur = null;
    D.variants.forEach(function (v) { if (v.id === D.selected) cur = v; });
    var sel = (cur || D.variants[0]).o.slice();
    var notice = $('[data-imods-notice]', form);
    var startNotice = '';
    if (stockDriveGuard && is2000(sel[iBat]) && !isFlash(sel[iSto])) {       // a deep link to a stock-drive + 2000mAh variant
      sel[iBat] = stdBattery(); startNotice = R.battery2000.switchBack;
    }
    if (iSto >= 0 && !storageAllowed(sel[iSto])) sel[iSto] = firstAllowedStorage();
    function stdBattery() { var l = $$('input[data-optval]', byRole.battery || document.createElement('div')).map(function (x) { return x.value; }).filter(function (x) { return !is2000(x) && !is1200(x); }); return l[0] || sel[iBat]; }
    function firstAllowedStorage() { var l = $$('input[data-optval]', byRole.storage).map(function (x) { return x.value; }); return l[0]; }

    // part: the service and add-on groups
    var gate = $('[data-imods-gate]', form);
    var gateVal = null;
    if (gate && (I.state === 'hard-drive' || I.state === 'flash-fit')) {
      gateVal = I.state === 'hard-drive' ? 'hdd' : 'flash';
      var gi = $('input[value="' + gateVal + '"]', gate); if (gi) gi.checked = true;
    }
    if (kind === 'part' && iSvc >= 0 && /[?&]install=yes/.test(location.search)) {
      var inst = $$('input[data-optval]', byRole.service).map(function (x) { return x.value; }).filter(function (v) { return isInstall(v) && !isInstallBox(v); })[0];
      if (inst) sel[iSvc] = inst;
    }

    // finishes (new case)
    var finWrap = $('[data-imods-finishes]', form);
    var finSets = finWrap ? $$('fieldset[data-opt="finish"]', finWrap) : [];
    var colors = [];
    var colorFs = $('[data-imods-color-choice]', form);
    var customFs = $('[data-imods-custom-choice]', form);        // R3 guard (snippets/imods-custom-choices.liquid): required, nothing preselected
    try { colors = JSON.parse(($('[data-imods-colors]', form) || {}).textContent || '[]') || []; } catch (e) {}
    // round 120: builder links carry properties[Part]=Finish; preselect those finishes
    try {
      new URLSearchParams(location.search).forEach(function (val, key) {
        var m = /^properties\[(.+)\]$/.exec(key); if (!m) return;
        finSets.forEach(function (fs) { if (fs.getAttribute('data-part') === m[1]) { var r = $('input[value="' + CSS.escape(val) + '"]', fs); if (r) r.checked = true; } });
        if (colorFs && m[1] === 'Color') { var rc = $('input[value="' + CSS.escape(val) + '"]', colorFs); if (rc) rc.checked = true; }
      });
    } catch (e) {}

    // ---- labels that never change
    labelStatic();
    // stable keys for each choice (tests and deep links): used/new, std/2000, capacity, part/install/installbox, no/yes, none/kit/service
    fsets.forEach(function (fs) {
      var role = fs.getAttribute('data-opt');
      $$('input[data-optval]', fs).forEach(function (inp) {
        var v = inp.value, k = v;
        if (role === 'case') k = isNewCase(v) ? 'new' : 'used';
        else if (role === 'battery') k = is2000(v) ? '2000' : (is1200(v) ? '1200' : 'std');
        else if (role === 'storage') { var c = capOf(v); k = c ? c.label : v; }
        else if (role === 'service') k = isInstallBox(v) ? 'installbox' : (isInstall(v) ? 'install' : 'part');
        else if (role === 'box') k = isYes(v) ? 'yes' : 'no';
        else if (role === 'addbattery') k = isNone(v) ? 'none' : (is2000(v) ? '2000' : (is1200(v) ? '1200' : 'battery'));
        else if (role === 'addon') k = isNone(v) ? 'none' : (isFlashAddon(v) ? (/service/i.test(v) ? 'service' : 'kit') + (/battery/i.test(v) ? '-battery' : '') : 'addon-' + addonName(v).toLowerCase().replace(/[^a-z0-9]+/g, '-'));
        inp.setAttribute('data-key', k);
      });
    });
    function labelStatic() {
      if (iCase >= 0) $$('label[data-value]', byRole.case).forEach(function (l) {
        var v = l.getAttribute('data-value');
        if (isNewCase(v)) { $('[data-label]', l).textContent = R.caseLabels.new; $('[data-sub]', l).textContent = R.caseLabels.newSub; }
        else { $('[data-label]', l).textContent = R.caseLabels.used; $('[data-sub]', l).textContent = D.color ? D.color + ", the iPod's own case" : "The iPod's own case"; }
      });
      if (iBat >= 0) $$('label[data-value]', byRole.battery).forEach(function (l) {
        var v = l.getAttribute('data-value');
        $('[data-label]', l).textContent = batWord(v) ? 'New ' + batWord(v) + ' extended-life battery' : 'New standard battery (included)';
      });
      if (iSto >= 0) $$('label[data-value]', byRole.storage).forEach(function (l) {
        var v = l.getAttribute('data-value'), c = capOf(v);
        $('[data-label]', l).textContent = c ? c.label : v;
        $('[data-sub]', l).textContent = isFlashSize(v) ? 'Flash' : 'Hard drive';
      });
      if (iBox >= 0) $$('label[data-value]', byRole.box).forEach(function (l) {
        var v = l.getAttribute('data-value');
        $('[data-label]', l).textContent = isYes(v) ? R.boxes.addonLabel : R.boxes.selfLabel;
      });
      addSets.forEach(function (fs) {
        $$('label[data-value]', fs).forEach(function (l) {
          var v = l.getAttribute('data-value');
          $('[data-label]', l).textContent = addName(fs, v);
          if (!isNone(v) && D.is2000 && isFlashAddon(v)) $('[data-sub]', l).textContent = 'No flash storage yet? This cell needs the room a flash conversion frees: add the flash upgrade.';
        });
      });
      // two add-on groups: each takes its own option name as its heading ("Add-on", "Upgrade and save")
      var addonSets = addSets.filter(function (f) { return f.getAttribute('data-opt') === 'addon'; });
      if (addonSets.length > 1) addonSets.forEach(function (fs) {
        var n = (fs.getAttribute('data-name') || '').trim(), lg = $('legend', fs);
        if (n && lg) lg.textContent = n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
      });
    }

    // ---- the render pass
    var firstRender = true;
    function render(changedRole) {
      // part: box only under We Fix It; the add-on value follows the service (kit with part only, service installed)
      if (kind === 'part') {
        var installed = iSvc >= 0 && isInstall(sel[iSvc]);
        if (virt) virt.normalize();
        if (iBox >= 0) {
          byRole.box.hidden = !installed;
          if (!installed) sel[iBox] = $$('input[data-optval]', byRole.box).map(function (x) { return x.value; }).filter(function (v) { return !isYes(v); })[0];
        }
        addSets.forEach(function (fs) {
          var ia = +fs.getAttribute('data-index'), vals = valsAt(fs);
          // a flash kit becomes the flash service under We Fix It and back; every other add-on keeps its own value
          var cur0 = sel[ia];
          if (isFlashAddon(cur0)) {
            var tw = addonTwin(cur0, vals);
            if (tw && (installed ? /kit/i.test(cur0) : /service/i.test(cur0))) sel[ia] = tw;
            else if (!tw && !installed && /service/i.test(cur0)) sel[ia] = diyFlashDrop(cur0, vals);
          }
          $$('label[data-value]', fs).forEach(function (l) {
            var v = l.getAttribute('data-value'), tw2 = addonTwin(v, vals);
            l.hidden = !!(tw2 && (installed ? /kit/i.test(v) : /service/i.test(v))) || (!tw2 && !installed && isFlashAddon(v) && /service/i.test(v));
          });
        });
      }
      // units: the 2000mAh fits flash builds only (R-2026-09-24-08)
      var hdd = iSto >= 0 && !isFlash(sel[iSto]);
      var batFs = byRole.battery;
      if (stockDriveGuard && batFs) {
        var bad = hdd;
        if (bad && is2000(sel[iBat])) {
          sel[iBat] = stdBattery();
          if (!firstRender) say(R.battery2000.switchBack);
        }
        $$('input[data-optval]', batFs).forEach(function (inp) {
          if (is2000(inp.value)) { inp.setAttribute('aria-disabled', bad ? 'true' : 'false'); }
        });
        var rs = $('[data-reason]', batFs);
        if (rs) { rs.hidden = !bad; $('span', rs).textContent = R.battery2000.reason; }
      }
      // resolve the variant; fall back to the closest offered one
      var v = find(sel);
      if (!offered(v)) {
        var alt = D.variants.filter(offered).sort(function (a, b) {
          var sa = 0, sb = 0;
          for (var j = 0; j < sel.length; j++) { if (a.o[j] === sel[j]) sa += (j === indexOfRole(changedRole) ? 10 : 1); if (b.o[j] === sel[j]) sb += (j === indexOfRole(changedRole) ? 10 : 1); }
          return sb - sa;
        })[0];
        if (alt) { v = alt; sel = alt.o.slice(); }
      }
      cur = v;
      // check the radios that match the selection
      fsets.forEach(function (fs) {
        var i = +fs.getAttribute('data-index');
        var sv = fs === byRole.service && isInstallBox(sel[i]) ? instValue() : sel[i];   // R-2026-09-27-05: box = an Add-ons tick
        $$('input[data-optval]', fs).forEach(function (inp) { inp.checked = inp.value === sv; });
      });
      // chip and card prices (D-14 A: the total you would pay)
      if (iSto >= 0) $$('label[data-value]', byRole.storage).forEach(function (l) {
        var val = l.getAttribute('data-value'), vals = withVal(sel, iSto, val);
        if (stockDriveGuard && !isFlash(val) && is2000(vals[iBat])) vals[iBat] = stdBattery();
        var p = price(vals);
        $('[data-price]', l).textContent = p != null ? money(p) : '';
        var inp = $('input', l); if (p == null) inp.setAttribute('aria-disabled', 'true'); else inp.removeAttribute('aria-disabled');
      });
      if (iCase >= 0) $$('label[data-value]', byRole.case).forEach(function (l) {
        var val = l.getAttribute('data-value');
        if (!isNewCase(val)) { $('[data-price]', l).textContent = ''; return; }
        var used = $$('input[data-optval]', byRole.case).map(function (x) { return x.value; }).filter(function (x) { return !isNewCase(x); })[0];
        var a = price(withVal(sel, iCase, val)), b = price(withVal(sel, iCase, used));
        var add = (a != null && b != null) ? a - b : null;
        $('[data-label]', l).textContent = R.caseLabels.new + (add != null ? ': +' + money(add) : '');
        $('[data-price]', l).textContent = '';
      });
      if (iBat >= 0) $$('label[data-value]', byRole.battery).forEach(function (l) {
        var val = l.getAttribute('data-value');
        if (!batWord(val)) { $('[data-price]', l).textContent = ''; return; }
        var ref = sel.slice();
        if (hdd && is2000(val)) { var fl = $$('input[data-optval]', byRole.storage).map(function (x) { return x.value; }).filter(isFlash)[0]; if (fl) ref[iSto] = fl; }
        var a = price(withVal(ref, iBat, val)), b = price(withVal(ref, iBat, stdBattery()));
        $('[data-label]', l).textContent = 'New ' + batWord(val) + ' extended-life battery' + (a != null && b != null ? ': +' + money(a - b) : '');
      });
      if (iSvc >= 0) $$('label[data-value]', byRole.service).forEach(function (l) {
        var val = l.getAttribute('data-value'), vals = forService(sel, val);
        var p = price(vals), from = p == null ? lowestWith(iSvc, val) : null;
        // FIX-10 set 7 (f) (FINDINGS #13): each card prices what a click on it gives (forService); if that exact set is not
        // sold, the card says "from" the lowest price it has, never nothing and never a set that is not sold
        $('[data-price]', l).textContent = p != null ? money(p) : (from != null ? 'from ' + money(from) : '');
        if (isInstallBox(val)) {
          l.hidden = true;           // owner R-2026-09-27-05: no "We Fix It + box" card; the box is a tick in Add-ons (We Fix It only)
        } else if (isInstall(val)) {
          var vNoBox = iBox >= 0 ? withVal(vals, iBox, $$('input[data-optval]', byRole.box).map(function (x) { return x.value; }).filter(function (x) { return !isYes(x); })[0]) : vals;
          // the installation alone: the box is its own Add-ons tick (R-2026-09-27-05); FIX-10 set 7 (f): and the add-ons are
          // priced in their own rows, so the charge is the part's own installation, the same whatever is ticked
          addSets.forEach(function (fs) { var i = +fs.getAttribute('data-index'); vNoBox = withVal(vNoBox, i, noneAt(fs) || vNoBox[i]); });
          var pIn = price(vNoBox);
          var partVal = $$('input[data-optval]', byRole.service).map(function (x) { return x.value; }).filter(function (x) { return !isInstall(x); })[0];
          var part = partVal != null ? price(withVal(vNoBox, iSvc, partVal)) : null;   // round 1 (I-23): installed-only = no part price
          // FIX-10 set 10 (owner round 6 "W3 Short", FINDINGS #33): the installation's +$ raised beside We Fix It, the owner's
          // words in the line; the card price (data-price) is untouched: what a click on the card gives (set 7 f)
          $('[data-sub]', l).textContent = partVal != null ? 'Let us perform the repair' : 'Installed by iMods: mail us your iPod';
          $('[data-label]', l).innerHTML = 'We Fix It' + (pIn != null && part != null ? ' <sup class="im-svc-add">+' + I.esc(money(pIn - part)) + '</sup>' : '');
        } else {
          $('[data-label]', l).textContent = 'You Fix It';
          $('[data-sub]', l).textContent = 'Part only, with a free pry tool';
        }
      });
      if (iBox >= 0) $$('label[data-value]', byRole.box).forEach(function (l) {
        var val = l.getAttribute('data-value');
        if (!isYes(val)) { $('[data-price]', l).textContent = ''; return; }
        var no = $$('input[data-optval]', byRole.box).map(function (x) { return x.value; }).filter(function (x) { return !isYes(x); })[0];
        var a = price(withVal(sel, iBox, val)), b = price(withVal(sel, iBox, no));
        $('[data-label]', l).textContent = R.boxes.addonLabel + (a != null && b != null ? ': +' + money(a - b) : '');
      });
      addSets.forEach(function (fs) {
        var ia = +fs.getAttribute('data-index'), none = noneAt(fs);
        $$('label[data-value]', fs).forEach(function (l) {
          var val = l.getAttribute('data-value'); if (isNone(val)) return;
          var a = price(withVal(sel, ia, val)), b = price(withVal(sel, ia, none));
          var save = saveTag(val, iSvc >= 0 && isInstall(sel[iSvc]));
          // owner R-2026-09-26-23 (c): the saving is a small raised badge, not "(5% off)" in the sentence
          $('[data-label]', l).innerHTML = I.esc(addName(fs, val) + (a != null && b != null ? ': +' + money(a - b) : '')) + (save ? ' <sup class="im-save">' + I.esc(save) + '</sup>' : '');
        });
      });
      // storage notes from the rules block
      if (iSto >= 0) {
        var notes = $('[data-notes]', byRole.storage), h = [];
        var c = capOf(sel[iSto]);
        if (famRules.notes && c && famRules.notes[c.label] && isFlash(sel[iSto])) h.push(famRules.notes[c.label]);
        if (famRules.flashNote && !flashBuild) h.push(famRules.flashNote);
        if (cap30) h.push(famRules.cap30.note);
        if (fam === '5G' && !cap30 && famRules.madeToOrder) h.push(famRules.madeToOrder.replace('contact us', '<a href="/pages/contact">contact us</a>'));
        if (fam === '5G' && flashBuild && famRules.memoryLine) h.push(famRules.memoryLine);
        notes.innerHTML = h.map(function (t) { return '<p class="im-note im-decision"><span>' + (t.indexOf('<a ') >= 0 ? t : I.esc(t)) + '</span></p>'; }).join('');
      }
      // finishes: only with the new case; nothing preselected
      var newCase = iCase >= 0 && isNewCase(sel[iCase]);
      if (finWrap) finWrap.hidden = !newCase;
      var missing = 0, firstMissing = null;
      if (newCase) finSets.forEach(function (fs) {
        var ch = $('input:checked', fs);
        var lab = $('[data-finish-chosen]', fs); if (lab) lab.textContent = ch ? ch.value : 'Choose one';
        if (!ch) { missing++; if (!firstMissing) firstMissing = fs; }
      });
      // G-33: the colour from custom.color_choices (required; hidden while a new case takes its finishes instead)
      var needColor = false;
      if (colorFs) {
        var showC = !(kind === 'unit' && newCase);
        colorFs.hidden = !showC;
        var cch = $('input:checked', colorFs), clab = $('[data-color-chosen]', colorFs);
        if (clab) clab.textContent = cch ? cch.value : 'Choose one';
        needColor = showC && !cch;
      }
      var needCustom = false;
      if (customFs) {
        var cuc = $('input:checked', customFs), cul = $('[data-custom-chosen]', customFs);
        if (cul) cul.textContent = cuc ? cuc.value : 'Choose one';
        needCustom = !cuc;
      }
      // price, breakdown, facts
      var total = cur ? cur.price : null;
      var mtOn = !!(mtTick && mtTick.checked && total != null);   // the ticked music transfer: its own cart line, counted here
      if (mtOn) total += mtPrice;
      $('[data-imods-price]', root).textContent = total != null ? money(total) : 'Price unavailable';
      var sticky = $('[data-sticky-price]', root); if (sticky) sticky.textContent = total != null ? money(total) : '';
      var bd = breakdown();
      if (mtOn) bd = (bd || money(cur.price)) + ' + music transfer ' + money(mtPrice);
      $('[data-imods-breakdown]', root).textContent = bd;
      var fs1 = $('[data-fact="storage"]', root), fb = $('[data-fact="battery"]', root);
      if (fs1 && iSto >= 0) { var cc = capOf(sel[iSto]); fs1.textContent = (cc ? cc.label : '') + (isFlash(sel[iSto]) ? ' flash' : ' hard drive'); }
      if (fb && iBat >= 0) fb.textContent = batWord(sel[iBat]) ? 'New ' + batWord(sel[iBat]) + ' battery' : 'New battery';
      // trust rows and the returns line (one setting; a stock unit always reads 30 days)
      if (kind === 'unit') {
        var flash = iSto >= 0 && isFlash(sel[iSto]) && !flashBuild ? true : flashBuild;
        var tc = $('[data-trust-cond]', root);
        if (tc) tc.textContent = newCase ? R.condition.newCase : (flash ? R.condition.flash : R.condition.original);
        var fsale = I.isFinalSale({ newCase: newCase, flash: iSto >= 0 && isFlash(sel[iSto]), battery2000: iBat >= 0 && is2000(sel[iBat]) });
        var li = $('[data-imods-returns]', root);
        if (li) {
          var span = li.querySelector('span');
          span.innerHTML = '<a href="/pages/warranty-and-returns">1-year limited warranty</a>' +
            (fsale ? '<span class="im-final" data-final-sale>. ' + I.esc(R.returns.finalSale) + '</span>' : ' · <span data-returns-text>' + I.esc(R.returns.thirty) + '</span>');
        }
      }
      // part: the trust row follows the service (FIX-6): pry tool with You Fix It, the repair line with We Fix It
      if (kind === 'part') {
        var instT = iSvc >= 0 && isInstall(sel[iSvc]);
        var tp = $('[data-trust-pry]', root), tr = $('[data-trust-repair]', root);
        if (tp) tp.hidden = instT; if (tr) tr.hidden = !instT;
      }
      // part: the storage gate (FIX B-16)
      var gateOk = true, gateMsg = '';
      if (gate) {
        var g = $('input:checked', gate); gateVal = g ? g.value : null;
        var hasAddon = addIdx.some(function (ia) { return isFlashAddon(sel[ia]); });
        gateOk = gateVal === 'flash' || hasAddon;
        var gm = $('[data-gate-msg]', gate), gu = $('[data-gate-unsure]', gate);
        gm.hidden = !(gateVal === 'hdd' && !hasAddon);
        gm.textContent = 'Fits flash-storage builds only. Tick Flash storage upgrade below, or choose the battery for your hard drive.';
        gu.hidden = gateVal !== 'unsure';
      }
      // add button and sticky label
      var addBtn = $('[data-imods-add]', form), lab = $('[data-add-label]', addBtn);
      var installedNow = kind === 'part' && iSvc >= 0 && isInstall(sel[iSvc]);
      var blocked = !cur || !offered(cur) || missing > 0 || needColor || needCustom || !gateOk;
      addBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      addBtn.dataset.firstMissing = '';
      if (missing > 0) lab.textContent = 'Choose ' + missing + ' more finish' + (missing > 1 ? 'es' : '');
      else if (needColor) lab.textContent = 'Choose a color';
      else if (needCustom) lab.textContent = 'Choose the ' + (customFs.getAttribute('data-name') || 'option').toLowerCase();
      else if (!gateOk) lab.textContent = 'Check your storage first';
      else if (!cur || !offered(cur)) lab.textContent = 'Sold out';
      else lab.textContent = installedNow ? 'Add repair to cart' : 'Add to cart';
      var sb = $('[data-sticky-btn]', root); if (sb) sb.textContent = lab.textContent;
      addBtn._firstMissing = firstMissing || (needColor ? colorFs : null) || (needCustom ? customFs : null) || (!gateOk ? gate : null);
      // hidden inputs: the variant id and the line-item properties
      $('[data-imods-id]', form).value = cur ? cur.id : '';
      var props = $('[data-imods-props]', form); props.innerHTML = '';
      if (newCase) finSets.forEach(function (fs) { var ch = $('input:checked', fs); if (ch) addProp(props, fs.getAttribute('data-part'), ch.value); });
      else if (colorFs && !colorFs.hidden) { var cc2 = $('input:checked', colorFs); if (cc2) addProp(props, 'Color', cc2.value); }
      else if (kind === 'unit' && colors.length === 1 && finSets.length) addProp(props, 'Color', colors[0]);
      if (customFs) { var cu2 = $('input:checked', customFs); if (cu2) addProp(props, customFs.getAttribute('data-name'), cu2.value); }
      // "What we did" follows the choice (T-product-refurb deck: the variant lines)
      var w1 = $('[data-wwd="battery"]'), w2 = $('[data-wwd="storage"]'), w3 = $('[data-wwd="case"]');
      if (w1 && iBat >= 0) w1.textContent = batWord(sel[iBat]) ? 'New ' + batWord(sel[iBat]) + ' battery fitted' : 'New battery fitted';
      if (w2 && iSto >= 0) { var cw = capOf(sel[iSto]); w2.textContent = isFlash(sel[iSto]) ? (cw ? cw.label : '') + ' flash card and adapter fitted, formatted and restored' : 'Original ' + (cw ? cw.label : '') + ' hard drive, tested during restore and sync'; }
      if (w3 && iCase >= 0) w3.textContent = newCase ? 'New aftermarket case in the colors you chose' : 'Original Apple case with normal signs of use';
      // the summary
      summary(newCase);
      if (virt) virt.sync();
      // URL
      if (cur && !firstRender) { try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(null, '', u); } catch (e) {} }
      firstRender = false;
    }
    function instValue() { return $$('input[data-optval]', byRole.service).map(function (x) { return x.value; }).filter(function (x) { return isInstall(x) && !isInstallBox(x); })[0]; }
    function indexOfRole(r) { return r ? idxOf(r) : -1; }
    function addProp(host, k, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = v; host.appendChild(i); }
    function say(t) { if (!notice) return; notice.textContent = ''; setTimeout(function () { notice.textContent = t; }, 30); }

    function breakdown() {
      if (!cur) return '';
      if (kind === 'unit') {
        var used = iCase >= 0 ? $$('input[data-optval]', byRole.case).map(function (x) { return x.value; }).filter(function (x) { return !isNewCase(x); })[0] : null;
        var std = iBat >= 0 ? stdBattery() : null;
        var base = sel.slice(); if (iCase >= 0) base[iCase] = used; if (iBat >= 0) base[iBat] = std;
        var pb = price(base); if (pb == null) return '';
        var parts = [], c = iSto >= 0 ? capOf(sel[iSto]) : null;
        var withCase = base.slice(); if (iCase >= 0) withCase[iCase] = sel[iCase];
        var pc = price(withCase);
        if (iCase >= 0 && isNewCase(sel[iCase]) && pc != null) parts.push('new case ' + money(pc - pb));
        if (iBat >= 0 && batWord(sel[iBat]) && pc != null) parts.push(batWord(sel[iBat]) + ' battery ' + money(cur.price - pc));
        if (!parts.length) return '';
        return (c ? c.label + (isFlash(sel[iSto]) ? ' flash' : ' hard drive') + ' unit ' : 'Unit ') + money(pb) + ' + ' + parts.join(' + ');
      }
      if (iSvc < 0) return '';
      var partOnly = $$('input[data-optval]', byRole.service).map(function (x) { return x.value; }).filter(function (x) { return !isInstall(x); })[0];
      var noBox = iBox >= 0 ? $$('input[data-optval]', byRole.box).map(function (x) { return x.value; }).filter(function (x) { return !isYes(x); })[0] : null;
      function noAdds(vals) { addSets.forEach(function (fs) { vals = withVal(vals, +fs.getAttribute('data-index'), noneAt(fs)); }); return vals; }
      if (partOnly == null) {                              // round 1 (I-23): installed-only (the flash mod services): installed, box, add-ons
        var bi = withVal(withVal(noAdds(sel), iBox, noBox), iSvc, instValue()), pi = price(bi);
        if (pi == null) return '';
        var outI = ['Installed ' + money(pi)], runI = withVal(noAdds(sel), iBox, noBox), prI = pi;
        if (isInstallBox(sel[iSvc])) { var pbx = price(runI); if (pbx != null) { outI.push('box and label ' + money(pbx - pi)); prI = pbx; } }
        else runI = bi;
        if (iBox >= 0 && isYes(sel[iBox])) { var pb2 = price(withVal(runI, iBox, sel[iBox])); if (pb2 != null) { outI.push('box and label ' + money(pb2 - prI)); prI = pb2; runI = withVal(runI, iBox, sel[iBox]); } }
        addSets.forEach(function (fs) {
          var ia = +fs.getAttribute('data-index'); if (isNone(sel[ia]) || prI == null) return;
          runI = withVal(runI, ia, sel[ia]); var pn = price(runI);
          if (pn != null) outI.push(addName(fs, sel[ia]).replace(/^./, function (c) { return c.toLowerCase(); }) + ' ' + money(pn - prI));
          prI = pn;
        });
        return outI.length > 1 ? outI.join(' + ') : '';
      }
      var b0 = withVal(withVal(noAdds(sel), iSvc, partOnly), iBox, noBox);
      var p0 = price(b0); if (p0 == null) return '';
      var out = ['Part ' + money(p0)];
      var inst = isInstall(sel[iSvc]);
      var b1 = withVal(noAdds(sel), iBox, noBox), p1 = price(b1);
      if (inst && isInstallBox(sel[iSvc])) {                // the flash kits' installed + box value: installation, then the box
        var pI = price(withVal(b1, iSvc, instValue()));
        if (pI != null && p1 != null) { out.push('installation ' + money(pI - p0)); out.push('box and label ' + money(p1 - pI)); }
      } else if (inst && p1 != null) out.push('installation ' + money(p1 - p0));
      var b2 = noAdds(sel), p2 = price(b2);
      if (inst && iBox >= 0 && isYes(sel[iBox]) && p2 != null && p1 != null) out.push('box and label ' + money(p2 - p1));
      // each add-on in turn: what it adds on top of the ones before it
      var run = b2, pr = p2;
      addSets.forEach(function (fs) {
        var ia = +fs.getAttribute('data-index'); if (isNone(sel[ia]) || pr == null) return;
        run = withVal(run, ia, sel[ia]); var pn = price(run);
        if (pn != null) out.push(addName(fs, sel[ia]).replace(/^./, function (c) { return c.toLowerCase(); }) + ' ' + money(pn - pr));
        pr = pn;
      });
      return out.length > 1 ? out.join(' + ') : '';
    }

    function summary(newCase) {
      var det = $('[data-imods-summary]', root); if (!det || !cur) return;
      var rows = [['Base unit', D.title]];
      if (iCase >= 0) rows.push(['Case', newCase ? R.caseLabels.new : R.caseLabels.used]);
      if (newCase) finSets.forEach(function (fs) { var ch = $('input:checked', fs); rows.push([fs.getAttribute('data-part'), ch ? ch.value : 'Not chosen yet']); });
      if (iSto >= 0) { var c = capOf(sel[iSto]); rows.push(['Storage', (c ? c.label : sel[iSto]) + (isFlash(sel[iSto]) ? ' flash' : ' hard drive')]); }
      if (iBat >= 0) rows.push(['Battery', batWord(sel[iBat]) ? 'New ' + batWord(sel[iBat]) + ' extended-life battery' : 'New standard battery']);
      rows.push(['Total', money(cur.price)]);
      var nch = rows.length - 2;
      $('[data-summary-label]', det).textContent = 'Your iPod: ' + nch + (nch === 1 ? ' choice, ' : ' choices, ') + money(cur.price);
      $('[data-summary-rows]', det).innerHTML = rows.map(function (r) { return '<dt>' + I.esc(r[0]) + '</dt><dd>' + I.esc(r[1]) + '</dd>'; }).join('');
    }


    // ---- one "Add-ons" panel (owner R-2026-09-26-23, -27, R-2026-09-27-03, -05): the plain add-ons, ONE "Flash storage
    // upgrade" row with its sizes, and the box and prepaid label (We Fix It only). The shared imods.addonPanel draws it (the
    // cart's "Change choices" uses the same one); the store's own option groups stay in the form, hidden, and carry the pick.
    var virt = null;
    (function () {
      if (kind !== 'part' || !I.addonPanel) return;
      var roles = [], vals = [];
      fsets.forEach(function (fs) { var i = +fs.getAttribute('data-index'); roles[i] = fs.getAttribute('data-opt'); vals[i] = valsAt(fs); });
      for (var k = 0; k < sel.length; k++) { if (!roles[k]) { roles[k] = 'other'; vals[k] = []; } }
      virt = I.addonPanel({
        roles: roles, vals: vals, sel: function () { return sel; }, set: function (i, v) { sel[i] = v; }, price: price,
        installed: function () { return iSvc >= 0 && isInstall(sel[iSvc]); }, isInstall: isInstall,
        comboMode: ((R.addons || {}).flashCombo) || 'block', uid: 'bb-' + String(D.handle || Math.random().toString(36).slice(2, 8)).slice(0, 40),
        boxLabel: R.boxes && (R.boxes.panelLabel || R.boxes.addonLabel),   // FIX-10 set 9 (d): the owner's words, page only (the cart line keeps the store's value until R31)
        flashNote: D.is2000 ? 'No flash storage yet? This cell needs the room a flash conversion frees: add the flash upgrade.' : ''
      });
      if (!virt) return;
      var olds = fsets.filter(function (f) { return /^(addon|addbattery|box)$/.test(f.getAttribute('data-opt')); });
      if (olds.length) olds[0].parentNode.insertBefore(virt.el, olds[0]);
      else if (byRole.service) byRole.service.parentNode.insertBefore(virt.el, byRole.service.nextSibling);
      else return;
      var sync0 = virt.sync;
      virt.sync = function () { olds.forEach(function (f) { f.hidden = true; }); sync0(); };
      virt.el.addEventListener('change', function (e) {
        if (virt.handle(e.target)) { e.stopPropagation(); render('addon'); }
      });
    })();
    // the music transfer: shown with JavaScript only, between the Add-ons and the box (the panel's flex order)
    if (mtFs) {
      mtFs.hidden = false; mtFs.style.order = '7';
      var bxs = virt && virt.el ? $('[data-virt-boxsec]', virt.el) : null;
      if (bxs) bxs.parentNode.insertBefore(mtFs, bxs); else if (virt && virt.el) virt.el.appendChild(mtFs);
    }
    // menus round 2 (owner §26/§27 R2-1, built 2026-10-17): the Flash Mods menu's button carries &music=1 when the visitor ticked the
    // music transfer there; the page arrives with its own tick ticked (the price and the cart follow the tick as before)
    if (mtTick && /[?&]music=1(&|$)/.test(location.search)) mtTick.checked = true;

    // ---- events
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[data-optval]')) {
        var fs = t.closest('fieldset[data-opt]');
        if (t.getAttribute('aria-disabled') === 'true') {        // disabled keeps its reason visible; the choice does not change
          render(null);
          var rs = $('[data-reason]', fs); if (rs && !rs.hidden) rs.focus && rs.setAttribute('tabindex', '-1');
          return;
        }
        sel[+fs.getAttribute('data-index')] = t.value;
        render(fs.getAttribute('data-opt'));
      } else if (t.matches('input[data-mt-tick]')) {
        render(null);
      } else if (t.closest('[data-imods-finishes]') || t.closest('[data-imods-gate]') || t.closest('[data-imods-color-choice]') || t.closest('[data-imods-custom-choice]')) {
        render(null);
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-imods-add]', form);
      if (btn.getAttribute('aria-disabled') === 'true') {
        var m = btn._firstMissing; if (m) { m.scrollIntoView({ block: 'center', behavior: 'smooth' }); var i = $('input', m); if (i) i.focus({ preventScroll: true }); }
        return;
      }
      if (btn._busy) return;
      btn._busy = true; btn.setAttribute('aria-busy', 'true');
      var err = $('[data-imods-add-error]', form); err.hidden = true;
      var fd = new FormData(form), props = {};
      fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = v; });
      var body = { id: +fd.get('id'), quantity: 1, sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: location.pathname };
      if (Object.keys(props).length) body.properties = props;
      if (mtTick && mtTick.checked && mtId) {   // the flash mod and the music transfer in one request: both go in, or neither
        var main = { id: body.id, quantity: 1 }; if (body.properties) main.properties = body.properties;
        var mtp = {}; mtp['For'] = mtFs.getAttribute('data-mt-for') || D.title || '';
        // the cart lists the newest line first: send the add-on first so the flash mod line leads, the add-on under it
        body = { items: [{ id: mtId, quantity: 1, properties: mtp }, main], sections: body.sections, sections_url: body.sections_url };
      }
      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'The cart did not accept this item.'); return j; }); })
        .then(function (j) {
          if (j.items && j.items.length && !j.key) {   // two lines added: the pop-up shows the flash mod
            var mi = j.items.filter(function (x) { return x.variant_id !== mtId; })[0] || j.items[0]; j.key = mi.key;
          }
          var cn = document.querySelector('cart-notification');
          if (cn && typeof cn.renderContents === 'function') cn.renderContents(j);
          else { var b = document.getElementById('cart-icon-bubble'); if (b && j.sections && j.sections['cart-icon-bubble']) { var d = document.createElement('div'); d.innerHTML = j.sections['cart-icon-bubble']; b.innerHTML = (d.querySelector('.shopify-section') || d).innerHTML; } }
        })
        .catch(function (e2) { err.textContent = 'This item was not added: ' + e2.message + ' Your choices are still here.'; err.hidden = false; })
        .then(function () { btn._busy = false; btn.removeAttribute('aria-busy'); });
    });
    var bar = $('[data-imods-sticky]', root);
    if (bar) bar.addEventListener('imods:sticky-tap', function (e) {
      var btn = $('[data-imods-add]', form);
      if (btn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); var m = btn._firstMissing || form; m.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    });

    render(null);
    if (startNotice) say(startNotice);
    if (kind === 'unit' && /[?&]yours=1(&|$)/.test(location.search) && /[?&]variant=\d+/.test(location.search)) yoursMode();

    // menus round 2 (owner I-14 "fit on the screen without scrolling so they can more easily add to cart"; R2-3 "use"; Q-R2-3 "only from
    // the menu button"; built 2026-10-17 from mock site_ideas_20261008/menus_r2/src/build.js): a unit page opened by the Shop iPods menu's
    // button (?variant=<id>&yours=1: every choice made) shows the choices as a short "Your iPod" list (case, storage, battery: the checked
    // options, read from the form itself) with a Change link each, and Add to cart right under it on the first screen. Change opens that
    // one choice in place (the others stay folded); the "Your iPod: 3 choices" line lower down says the same thing and folds into the list.
    // Without the mark (Google Shopping, every other link) the page is as before. Nothing about the order changes: the folded choices stay
    // checked in the same form.
    function yoursMode() {
      var sets = [['case', 'Case'], ['storage', 'Storage'], ['battery', 'Battery']].map(function (o) { return { key: o[0], lab: o[1], fs: $('fieldset[data-opt="' + o[0] + '"]', form) }; })
        .filter(function (x) { return x.fs && !x.fs.hidden; });
      if (!sets.length) return;
      function text(x) {
        var inp = $('input:checked', x.fs); if (!inp) return null;
        var v = inp.value;
        if (x.key === 'storage') { var m = /(\d+\s?(GB|TB))/i.exec(v); return m ? m[1].replace(' ', '') + (isFlash(v) ? ' flash' : ' hard drive') : v; }
        var l = inp.closest('label'), t = l && $('[data-label]', l);
        return (t && t.textContent.trim()) || v;
      }
      var wrap = document.createElement('div'); wrap.className = 'im-yb'; wrap.setAttribute('data-im-yb', '');
      form.insertBefore(wrap, form.firstChild);
      var open = null;
      function draw() {
        wrap.innerHTML = '<p class="im-yb__h">Your iPod</p><ul class="im-yb__list" role="list">' + sets.map(function (x) {
          return '<li class="im-yb__row' + (open === x.key ? ' is-open' : '') + '"><span class="im-yb__lab">' + x.lab + '</span><span class="im-yb__val">' + I.esc(text(x) || '—') + '</span>' +
            '<button type="button" class="im-yb__chg" data-chg="' + x.key + '" aria-expanded="' + (open === x.key) + '">' + (open === x.key ? 'Done' : 'Change') + '</button></li>';
        }).join('') + '</ul>';
        sets.forEach(function (x) { x.fs.classList.toggle('im-yb-folded', open !== x.key); });
      }
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-chg]'); if (!b) return;
        var k = b.getAttribute('data-chg'); open = open === k ? null : k; draw();
        var nb = $('[data-chg="' + k + '"]', wrap); if (nb) nb.focus();
      });
      form.addEventListener('change', function () { setTimeout(draw, 0); });
      var old = $('[data-imods-summary]', root); if (old) old.hidden = true;
      draw();
    }
  }
})();
